<template>
  <div class="content">
    <van-list v-model="loading" :finished="finished" @load="faechPage">
      <van-cell
        v-for="(item, index) in sectionList"
        :key="index"
        class="recommen_home"
      >
        <div>
          <div class="conter_banner" v-if="item.type == 6">
            <van-swipe :autoplay="3000">
              <van-swipe-item v-for="(i, k) in item.section_val" :key="k">
                <div v-if="i.open_mode == 2" @click="Urlopen(i)">
                  <img v-lazy="item.img_domain + i.thumb" />
                </div>
                <router-link
                  v-if="i.open_mode == 1 && i.inside_mode == 1"
                  :to="{
                    path: '/fictionList',
                    query: {
                      sid: i.novel_id,
                      nid: i.novel_id,
                      platform: $route.query.platform,
                      refer: refer,
                      lmId: item.id,
                      referId: referId,
                      ver: verNum,
                    },
                  }"
                >
                  <img v-lazy="item.img_domain + i.thumb" />
                </router-link>
                <router-link
                  v-if="i.open_mode == 1 && i.inside_mode == 2"
                  :to="{
                    path: '/hosDetails',
                    query: {
                      aid: i.anchor_id,
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                >
                  <img v-lazy="item.img_domain + i.thumb" />
                </router-link>
                <router-link
                  v-if="i.is_thematic == 1"
                  :to="{
                    path: '/special',
                    query: {
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                >
                  <img v-lazy="item.img_domain + i.thumb" />
                </router-link>
                <router-link
                  v-if="i.open_mode == 1 && i.inside_mode == 3"
                  :to="{
                    path: `/specialDesc/${i.thematic_id}`,
                    query: {
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                >
                  <img v-lazy="item.img_domain + i.thumb" />
                </router-link>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="others_list" v-if="item.type == 5">
            <div class="title">
              <div class="recommended">
                <i>
                  <img v-lazy="item.img_domain + item.logo" alt="" />
                </i>
                {{ item.name }}
              </div>
              <div class="square" v-if="item.display == 1">
                <router-link
                  :to="{
                    path: '/hostList',
                    query: {
                      sid: item.id,
                      name: item.name,
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                  >更多</router-link
                >
              </div>
            </div>
            <div class="img_col">
              <router-link
                :to="{
                  path: '/hosDetails',
                  query: {
                    aid: item.section_val.data_id_1_1,
                    platform: $route.query.platform,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img
                      v-lazy="item.img_domain + item.section_val.data_img_1_1"
                      alt=""
                    />
                  </div>
                  <div class="img_Lines">
                    {{ item.section_val.data_desc_1_1 }}
                  </div>
                </div>
              </router-link>
              <router-link
                :to="{
                  path: '/hosDetails',
                  query: {
                    aid: item.section_val.data_id_1_2,
                    platform: $route.query.platform,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img
                      v-lazy="item.img_domain + item.section_val.data_img_1_2"
                      alt=""
                    />
                  </div>
                  <div class="img_Lines">
                    {{ item.section_val.data_desc_1_2 }}
                  </div>
                </div>
              </router-link>
              <router-link
                :to="{
                  path: '/hosDetails',
                  query: {
                    aid: item.section_val.data_id_1_3,
                    platform: $route.query.platform,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img
                      v-lazy="item.img_domain + item.section_val.data_img_1_3"
                      alt=""
                    />
                  </div>
                  <div class="img_Lines">
                    {{ item.section_val.data_desc_1_3 }}
                  </div>
                </div>
              </router-link>
              <router-link
                :to="{
                  path: '/hosDetails',
                  query: {
                    aid: item.section_val.data_id_2_1,
                    platform: $route.query.platform,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img
                      v-lazy="item.img_domain + item.section_val.data_img_2_1"
                      alt=""
                    />
                  </div>
                  <div class="img_Lines">
                    {{ item.section_val.data_desc_2_1 }}
                  </div>
                </div>
              </router-link>
              <router-link
                :to="{
                  path: '/hosDetails',
                  query: {
                    aid: item.section_val.data_id_2_2,
                    platform: $route.query.platform,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img
                      v-lazy="item.img_domain + item.section_val.data_img_2_2"
                      alt=""
                    />
                  </div>
                  <div class="img_Lines">
                    {{ item.section_val.data_desc_2_2 }}
                  </div>
                </div>
              </router-link>
              <router-link
                :to="{
                  path: '/hosDetails',
                  query: {
                    aid: item.section_val.data_id_2_3,
                    platform: $route.query.platform,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img
                      v-lazy="item.img_domain + item.section_val.data_img_2_3"
                      alt=""
                    />
                  </div>
                  <div class="img_Lines">
                    {{ item.section_val.data_desc_2_3 }}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="hot_list" v-if="item.type == 3">
            <div class="title" v-if="moreList1[item.id]">
              <div class="recommended">
                <i>
                  <img v-lazy="item.img_domain + item.logo" alt="" />
                </i>
                {{ item.name }}
              </div>
              <div class="square" v-if="item.display == 1">
                <router-link
                  :to="{
                    path: '/moreList',
                    query: {
                      sid: item.id,
                      name: item.name,
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                  >更多</router-link
                >
              </div>
            </div>
            <router-link
              v-for="(i, index) in moreList1[item.id]"
              :key="index"
              :to="{
                path: '/fictionList',
                query: {
                  sid: i.id,
                  nid: i.id,
                  platform: $route.query.platform,
                  refer: refer,
                  lmId: item.id,
                  referId: referId,
                  ver: verNum,
                },
              }"
            >
              <div class="hot_view_list">
                <div class="img_info">
                  <img v-lazy="i.img" alt="" />
                </div>
                <div class="list_con">
                  <p>{{ i.name }}</p>
                  <p>{{ i.category_name }}</p>
                  <p>
                    {{ i.introduction }}
                  </p>
                  <div class="exhibition">
                    <span
                      ><i
                        ><img
                          src="../assets/images/home_ic_label.png"
                          alt="" /></i
                      >{{ i.anchor_name }}</span
                    >
                    <span>
                      <i
                        ><img src="../assets/images/details_ic.png" alt=""
                      /></i>
                      <span v-if="i.listen_type == 1">{{ i.listen_true }}</span>
                      <span v-if="i.listen_type == 2">{{ i.listen }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="new_list new_list_one" v-if="item.type == 4">
            <div class="title" v-if="moreList4[item.id]">
              <div class="recommended">
                <i>
                  <img v-lazy="item.img_domain + item.logo" alt="" />
                </i>
                {{ item.name }}
              </div>
              <div class="square" v-if="item.display == 1">
                <router-link
                  :to="{
                    path: '/moreList',
                    query: {
                      sid: item.id,
                      name: item.name,
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                  >更多</router-link
                >
              </div>
            </div>
            <div class="img_col">
              <router-link
                v-for="(i, index) in moreList4[item.id]"
                :key="index"
                :to="{
                  path: '/fictionList',
                  query: {
                    sid: i.id,
                    nid: i.id,
                    platform: $route.query.platform,
                    refer: refer,
                    lmId: item.id,
                    referId: referId,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img v-lazy="i.img" alt="" />
                  </div>
                  <div class="img_Lines">
                    <span>{{ i.name }}</span>
                    <span v-if="i.update_status == 1" class="color_active"
                      >更{{ i.numbers }}期</span
                    >
                    <span v-if="i.update_status == 2"
                      >全<i>{{ i.numbers }}</i
                      >期</span
                    >
                  </div>
                  <div class="label_name">
                    {{ i.category_name }}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="view_list" style="display: block" v-if="item.type == 1">
            <div class="title">
              <div class="recommended">
                <i>
                  <img v-lazy="item.img_domain + item.logo" alt="" />
                </i>
                {{ item.name }}
              </div>
              <div class="square" v-if="item.display == 1">
                <router-link
                  :to="{
                    path: '/moreList',
                    query: {
                      sid: item.id,
                      name: item.name,
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                  >更多</router-link
                >
              </div>
            </div>
            <div style="display: flex">
              <router-link
                :to="{
                  path: '/fictionList',
                  query: {
                    sid: item.section_val.data_left_id,
                    nid: item.section_val.data_left_id,
                    platform: $route.query.platform,
                    refer: refer,
                    lmId: item.id,
                    referId: referId,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_info">
                  <img
                    v-lazy="item.img_domain + item.section_val.data_left"
                    alt=""
                  />
                </div>
              </router-link>
              <div>
                <router-link
                  :to="{
                    path: '/fictionList',
                    query: {
                      sid: item.section_val.data_right_up_id,
                      nid: item.section_val.data_right_up_id,
                      platform: $route.query.platform,
                      refer: refer,
                      lmId: item.id,
                      referId: referId,
                      ver: verNum,
                    },
                  }"
                >
                  <div class="list_con">
                    <span class="oneList_two">
                      <p>{{ item.section_val.data_right_up_name }}</p>
                      <p>{{ item.section_val.data_right_up_title }}</p>
                    </span>
                    <img
                      v-lazy="
                        item.img_domain + item.section_val.data_right_up_img
                      "
                      alt=""
                    />
                  </div>
                </router-link>
                <router-link
                  :to="{
                    path: '/fictionList',
                    query: {
                      sid: item.section_val.data_right_down_id,
                      nid: item.section_val.data_right_down_id,
                      platform: $route.query.platform,
                      refer: refer,
                      lmId: item.id,
                      referId: referId,
                      ver: verNum,
                    },
                  }"
                >
                  <div class="list_con">
                    <span class="oneList_two">
                      <p>{{ item.section_val.data_right_down_name }}</p>
                      <p>{{ item.section_val.data_right_down_title }}</p>
                    </span>
                    <img
                      v-lazy="
                        item.img_domain + item.section_val.data_right_down_img
                      "
                      alt=""
                    />
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="new_list" v-if="item.type == 2">
            <div class="title" v-if="moreList2[item.id]">
              <div class="recommended">
                <i>
                  <img v-lazy="item.img_domain + item.logo" alt="" />
                </i>
                {{ item.name }}
              </div>
              <div class="square" v-if="item.display == 1">
                <router-link
                  :to="{
                    path: '/moreList',
                    query: {
                      sid: item.id,
                      name: item.name,
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                  >更多</router-link
                >
              </div>
            </div>
            <div class="img_col">
              <router-link
                v-for="(i, index) in moreList2[item.id]"
                :key="index"
                :to="{
                  path: '/fictionList',
                  query: {
                    sid: i.id,
                    nid: i.id,
                    platform: $route.query.platform,
                    refer: refer,
                    lmId: item.id,
                    referId: referId,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img v-lazy="i.img" alt="" />
                  </div>
                  <div class="img_Lines">
                    <span>{{ i.name }}</span>
                    <span v-if="i.update_status == 1" class="color_active"
                      >更{{ i.numbers }}期</span
                    >
                    <span v-if="i.update_status == 2"
                      >全<i>{{ i.numbers }}</i
                      >期</span
                    >
                  </div>
                  <div class="label_name">
                    {{ i.category_name }}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="new_list" v-if="item.type == 8">
            <div class="title" v-if="moreList8">
              <div class="recommended">
                <i>
                  <img v-lazy="item.img_domain + item.logo" alt="" />
                </i>
                {{ item.name }}
              </div>
              <div class="square" v-if="item.display == 1">
                <router-link
                  :to="{
                    path: '/moreList',
                    query: {
                      sid: item.id,
                      name: item.name,
                      last_update: 1,
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                  >更多</router-link
                >
              </div>
            </div>
            <div class="img_col">
              <router-link
                v-for="(i, index) in moreList8"
                :key="index"
                :to="{
                  path: '/fictionList',
                  query: {
                    sid: i.id,
                    nid: i.id,
                    platform: $route.query.platform,
                    refer: refer,
                    lmId: item.id,
                    referId: referId,
                    ver: verNum,
                  },
                }"
              >
                <div class="img_card">
                  <div class="img">
                    <img v-lazy="i.img" alt="" />
                  </div>
                  <div class="img_Lines">
                    <span>{{ i.name }}</span>
                    <span v-if="i.update_status == 1" class="color_active"
                      >更{{ i.numbers }}期</span
                    >
                    <span v-if="i.update_status == 2"
                      >全<i>{{ i.numbers }}</i
                      >期</span
                    >
                  </div>
                  <div class="label_name">
                    {{ i.category_name }}
                  </div>
                </div>
              </router-link>
            </div>
            <div @click="novelChange()" class="btn_change">
              <img src="../assets/images/change_btn.png" alt="" />
            </div>
          </div>
          <div class="hot_list" v-if="item.type == 7">
            <div class="title" v-if="moreList7[item.id]">
              <div class="recommended">
                <i>
                  <img v-lazy="item.img_domain + item.logo" alt="" />
                </i>
                {{ item.name }}
              </div>
              <div class="square" v-if="item.display == 1">
                <router-link
                  :to="{
                    path: '/moreList',
                    query: {
                      sid: item.id,
                      name: item.name,
                      platform: $route.query.platform,
                      ver: verNum,
                    },
                  }"
                  >更多</router-link
                >
              </div>
            </div>
            <router-link
              v-for="(i, index) in moreList7[item.id]"
              :key="index"
              :to="{
                path: '/fictionList',
                query: {
                  sid: i.id,
                  nid: i.id,
                  platform: $route.query.platform,
                  refer: refer,
                  lmId: item.id,
                  referId: referId,
                  ver: verNum,
                },
              }"
            >
              <div class="hot_view_list">
                <div class="img_info">
                  <img v-lazy="i.img" alt="" />
                </div>
                <div class="list_con">
                  <p>{{ i.name }}</p>
                  <p>{{ i.category_name }}</p>
                  <p>
                    {{ i.introduction }}
                  </p>
                  <div class="exhibition">
                    <span
                      ><i
                        ><img
                          src="../assets/images/home_ic_label.png"
                          alt="" /></i
                      >{{ i.anchor_name }}</span
                    >
                    <span>
                      <i
                        ><img src="../assets/images/details_ic.png" alt=""
                      /></i>
                      <span v-if="i.listen_type == 1">{{ i.listen_true }}</span>
                      <span v-if="i.listen_type == 2">{{ i.listen }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </van-cell>
    </van-list>
    <div v-if="!loading && finished" class="No_more" style="text-align: center">
      我也是有底线的
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import "../css/home.scss";
import "../css/Carousel.scss";
export default {
  name: "Home",
  data() {
    return {
      sectionList: [],
      sectionVal: [],
      sectionVal1: [],
      sectionVal2: [],
      moreList1: {},
      moreList2: {},
      moreList3: [],
      moreList4: {},
      moreList5: [],
      moreList7: {},
      moreList8: {},
      listParams: {
        page: 1,
        pageSize: 5,
        sectionId: 0,
      },
      listChange: {
        sectionId: 0,
        change: 1,
      },
      loading: false,
      finished: false,
      works: [],
      refer: "",
      referId: "",
    };
  },
  computed: {
    ...mapState("userIndex", ["Token", "musicId", "status", "verNum", "navIndex", "navList"]),
  },
  watch: {
    $route(to, from) {
      if (to) {
        this.finished = true;
        this.listParams.page = 1;
        this.listParams.pageSize = 5;
        this.listChange.change = 1;
        // 默认清空
        this.sectionList = [];
        this.getAllList();
        this.novelDefault();
        this.refer = this.navList[this.navIndex].name;
        this.referId = this.navList[this.navIndex].id;
      }
    },
  },
  created() {
   this.initData();
  },
  methods: {
    ...mapActions("userIndex", [
      "fetchNavSection",
      "fetchMulti",
      "fetchNavIgation",
      "fetchNavSection2",
    ]),
    ...mapMutations("userIndex", ["setMusicId", "setStatus", "setverNum", "setnNavList", "setnNavIndex"]),
    initData(){
      this.finished = true;
      this.listParams.page = 1;
      this.listParams.pageSize = 5;
      this.listChange.change = 1;
      // 默认清空
      this.sectionList = [];
      this.fetchNavIgation().then((res) => {
        let sectionId = this.$route.query.sectionId;
        let navList = res.data;
        let navIndex = navList.findIndex((r) => r.id == sectionId);
        navIndex = navIndex === -1 ? 0 : navIndex;
  
        this.setnNavList(navList);
        this.setnNavIndex(navIndex);

        this.getAllList(res);
        this.novelDefault(res);
      })
    },
    getAllList(res) {
      this.loading = true;
        this.listParams.sectionId = this.$route.query.sectionId || res.data[0].id;
        this.fetchNavSection(this.listParams).then((res) => {
          this.loading = false;
          if (res.data.length <= 0) {
            this.finished = true;
            return false;
          }
          this.finished = false;
          this.sectionList = res.data;
          let data = res.data;
          var arr = [];
          for (let k in data) {
            if (data[k].type == 3) {
              let send1 = [];
              let list = data[k].section_val.data_id_1_1;
              let list1 = data[k].section_val.data_id_2_1;
              let list2 = data[k].section_val.data_id_3_1;
              send1.push(list, list1, list2);
              let obj = {
                nid: send1,
              };
              this.fetchMulti(obj).then((res) => {
                let obj = {},
                  rerank = [];
                res.data.map((item) => {
                  obj[item.id] = item;
                });
                send1.map((item) => {
                  rerank.push(obj[item]);
                });
                this.moreList1[data[k].id] = rerank.filter(Boolean);
                this.$forceUpdate();
              });
            }
            if (data[k].type == 4) {
              let send3 = [];
              let list = data[k].section_val.data_id_1_1;
              let list1 = data[k].section_val.data_id_1_2;
              let list2 = data[k].section_val.data_id_1_3;
              send3.push(list, list1, list2);
              let obj = {
                nid: send3,
              };
              this.fetchMulti(obj).then((res) => {
                let obj = {},
                  rerank = [];
                res.data.map((item) => {
                  obj[item.id] = item;
                });
                send3.map((item) => {
                  rerank.push(obj[item]);
                });
                this.moreList4[data[k].id] = rerank;
                this.$forceUpdate();
              });
            }
            if (data[k].type == 2) {
              let send2 = [];
              let list = data[k].section_val.data_id_1_1;
              let list1 = data[k].section_val.data_id_1_2;
              let list2 = data[k].section_val.data_id_1_3;
              let list3 = data[k].section_val.data_id_2_1;
              let list4 = data[k].section_val.data_id_2_2;
              let list5 = data[k].section_val.data_id_2_3;
              send2.push(list, list1, list2, list3, list4, list5);
              let obj = {
                nid: send2,
              };
              this.fetchMulti(obj).then((res) => {
                let obj = {},
                  rerank = [];
                res.data.map((item) => {
                  obj[item.id] = item;
                });
                send2.map((item) => {
                  rerank.push(obj[item]);
                });
                this.moreList2[data[k].id] = rerank.filter(Boolean);
                this.$forceUpdate();
              });
            }
            if (data[k].type == 7) {
              let send7 = [];
              let list = data[k].section_val.data_id_1_1;
              let list1 = data[k].section_val.data_id_2_1;
              let list2 = data[k].section_val.data_id_3_1;
              let list3 = data[k].section_val.data_id_4_1;
              let list4 = data[k].section_val.data_id_5_1;
              let list5 = data[k].section_val.data_id_6_1;
              send7.push(list, list1, list2, list3, list4, list5);
              let obj = {
                nid: send7,
              };
              this.fetchMulti(obj).then((res) => {
                let obj = {},
                  rerank = [];
                res.data.map((item) => {
                  obj[item.id] = item;
                });
                send7.map((item) => {
                  rerank.push(obj[item]);
                });
                this.moreList7[data[k].id] = rerank.filter(Boolean);
                this.$forceUpdate();
              });
            }
          }
        });
    },
    faechPage() {
      this.listParams.page++;
      this.loading = true;
        this.listParams.sectionId = this.$route.query.sectionId || this.navList[0].id;
        this.fetchNavSection(this.listParams).then(async (res) => {
          this.loading = false;
          if (res.data.length <= 0) {
            this.finished = true;
            return false;
          }
          this.sectionList = this.sectionList.concat(res.data);
          let data = res.data;
          var arr = [];
          for (let k in data) {
            if (data[k].type == 3) {
              let send1 = [];
              let list = data[k].section_val.data_id_1_1;
              let list1 = data[k].section_val.data_id_2_1;
              let list2 = data[k].section_val.data_id_3_1;
              send1.push(list, list1, list2);
              let obj = {
                nid: send1,
              };
              await this.fetchMulti(obj).then((res) => {
                let obj = {},
                  rerank = [];
                res.data.map((item) => {
                  obj[item.id] = item;
                });
                send1.map((item) => {
                  rerank.push(obj[item]);
                });
                this.moreList1[data[k].id] = rerank.filter(Boolean);
                this.$forceUpdate();
                for (const iterator of rerank) {
                  let id = String(iterator.id);
                  if (!this.works.includes(id)) {
                    this.works.push(id);
                  }
                }
              });
            }
            if (data[k].type == 4) {
              let send3 = [];
              let list = data[k].section_val.data_id_1_1;
              let list1 = data[k].section_val.data_id_1_2;
              let list2 = data[k].section_val.data_id_1_3;
              send3.push(list, list1, list2);
              let obj = {
                nid: send3,
              };
              await this.fetchMulti(obj).then((res) => {
                let obj = {},
                  rerank = [];
                res.data.map((item) => {
                  obj[item.id] = item;
                });
                send3.map((item) => {
                  rerank.push(obj[item]);
                });
                this.moreList4[data[k].id] = rerank;
                this.$forceUpdate();
                for (const iterator of rerank) {
                  let id = String(iterator.id);
                  if (!this.works.includes(id)) {
                    this.works.push(id);
                  }
                }
              });
            }
            if (data[k].type == 2) {
              let send2 = [];
              let list = data[k].section_val.data_id_1_1;
              let list1 = data[k].section_val.data_id_1_2;
              let list2 = data[k].section_val.data_id_1_3;
              let list3 = data[k].section_val.data_id_2_1;
              let list4 = data[k].section_val.data_id_2_2;
              let list5 = data[k].section_val.data_id_2_3;
              send2.push(list, list1, list2, list3, list4, list5);
              let obj = {
                nid: send2,
              };
              await this.fetchMulti(obj).then((res) => {
                let obj = {},
                  rerank = [];
                res.data.map((item) => {
                  obj[item.id] = item;
                });
                send2.map((item) => {
                  rerank.push(obj[item]);
                });
                this.moreList2[data[k].id] = rerank.filter(Boolean);
                this.$forceUpdate();
                for (const iterator of rerank) {
                  let id = String(iterator.id);
                  if (!this.works.includes(id)) {
                    this.works.push(id);
                  }
                }
              });
            }
            if (data[k].type == 7) {
              let send7 = [];
              let list = data[k].section_val.data_id_1_1;
              let list1 = data[k].section_val.data_id_2_1;
              let list2 = data[k].section_val.data_id_3_1;
              let list3 = data[k].section_val.data_id_4_1;
              let list4 = data[k].section_val.data_id_5_1;
              let list5 = data[k].section_val.data_id_6_1;
              send7.push(list, list1, list2, list3, list4, list5);
              let obj = {
                nid: send7,
              };
              await this.fetchMulti(obj).then((res) => {
                let obj = {},
                  rerank = [];
                res.data.map((item) => {
                  obj[item.id] = item;
                });
                send7.map((item) => {
                  rerank.push(obj[item]);
                });
                this.moreList7[data[k].id] = rerank.filter(Boolean);
                this.$forceUpdate();
                for (const iterator of rerank) {
                  let id = String(iterator.id);
                  if (!this.works.includes(id)) {
                    this.works.push(id);
                  }
                }
              });
            }
          }

          this.refer = this.navList[this.navIndex].name;
          this.referId = this.navList[this.navIndex].id;
          let column = [];
          for (let index = 0; index < this.sectionList.length; index++) {
            let a = this.sectionList[index].id;
            column.push(String(a));
          }

          this.sensors.track(
            "YS_Home_recommendation",
            {
              tab: this.navList[this.navIndex].id,
              column_id_list: column,
              works_id: this.works,
            },
            () => {
              console.log("success");
            }
          );
        });
    },
    novelDefault(res) {
        this.listChange.sectionId = this.$route.query.sectionId || res.data[0].id;
        this.fetchNavSection2(this.listChange).then((res) => {
          let data = res.data;
          var arr = [];
          for (let k in data) {
            let send8 = [];
            let list = data[k].section_val.data_id_1_1;
            let list1 = data[k].section_val.data_id_1_2;
            let list2 = data[k].section_val.data_id_1_3;
            let list3 = data[k].section_val.data_id_2_1;
            let list4 = data[k].section_val.data_id_2_2;
            let list5 = data[k].section_val.data_id_2_3;
            send8.push(list, list1, list2, list3, list4, list5);
            let obj = {
              nid: send8,
            };
            this.fetchMulti(obj).then((res) => {
              let obj = {},
                rerank = [];
              res.data.map((item) => {
                obj[item.id] = item;
              });
              send8.map((item) => {
                rerank.push(obj[item]);
              });
              this.moreList8 = rerank.filter(Boolean);
              this.$forceUpdate();
            });
          }
        });
    },
    novelChange() {
      this.listChange.change++;
        this.listChange.sectionId = this.$route.query.sectionId || this.navList[0].id;
        this.fetchNavSection2(this.listChange).then((res) => {
          let data = res.data;
          for (let k in data) {
            let send8 = [];
            let list = data[k].section_val.data_id_1_1;
            let list1 = data[k].section_val.data_id_1_2;
            let list2 = data[k].section_val.data_id_1_3;
            let list3 = data[k].section_val.data_id_2_1;
            let list4 = data[k].section_val.data_id_2_2;
            let list5 = data[k].section_val.data_id_2_3;
            send8.push(list, list1, list2, list3, list4, list5);
            let obj = {
              nid: send8,
            };
            this.fetchMulti(obj).then((res) => {
              let obj = {},
                rerank = [];
              res.data.map((item) => {
                obj[item.id] = item;
              });
              send8.map((item) => {
                rerank.push(obj[item]);
              });
              this.moreList8 = rerank.filter(Boolean);
              this.$forceUpdate();
            });
          }
        });
    },
    Urlopen(i) {
      if (window.android) {
        window.android.callExplorer(i.link_url);
      }
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.callExplorer &&
        window.webkit.messageHandlers.callExplorer.postMessage
      ) {
        window.webkit.messageHandlers.callExplorer.postMessage(i.link_url);
      }
    },
  },
};
</script>
